const colors = {
    'david-yellow': '#fadf00',
    'david-black': '#050708',
    'error-border': '#bf282d',
    'error-bg': '#fff4f4',
    'error-text': '#bf282d',
    'success-border': '#188429',
    'success-bg': '#f7fbf8',
    'success-btn-bg': '#c3e8cb',
    'success-btn-hover': '#c3e0ca',
    'success-text': '#188429',
    'info-border': '#287bad',
    'info-bg': '#f4f8fb',
    'info-text': '#287bad',
    'dark-yellow': '#ffcd05',
    'light-yellow': '#fff285',
    'map-red': '#FF2424',
    'dark-red': '#DB0000',
    'map-green': '#2da322',
    'cluster-fill': '#0065c4',
    'dark-gray': '#343c40',
    'white': '#fff',
    'darker-red': '#912424',
    'lighter-yellow': '#fff7b3',
    'lighter-red': '#f74848',
};

export function getColorFromSlug(slug) {
    return colors[slug] || null;
}

export function getColor(color) {
    return getColorFromSlug(color) || color;
}
